<div class="surface-200 text-primary py-2 px-3 border-round font-bold text-sm">
  <i class="fa fa-person-walking-arrow-right mr-2"></i>
  <span>{{'Shared.CREATE-PROSPECT.HEADER_TOUR' | translate}}</span>
</div>

<div class="md:px-3 py-3" [formGroup]="parentForm()" >
  <div class="grid" formGroupName="tour_completed">
    <div class="col-6 md:col-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tour-conductor-label">{{'Shared.CREATE-PROSPECT.WHO_CONDUCTED_THE_TOUR' | translate}}</label>
      <staff-selector [formGroup]="parentForm()" [controlName]="assignedToFormControl" [id]="assignedTo$"
        [styleClass]="'w-full text-sm'" [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
        (selectedStaff)="getSelectedStaff($event)"
        aria-label="tour-conductor-selector"
        data-testid="tour-conductor-selector" />
      @if (assignedToFormControl && assignedToFormControl?.touched && assignedToFormControl?.invalid) {
        <app-error-msg [errors]="assignedToFormControl?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.WHO_CONDUCTED_THE_TOUR_ERROR' | translate" data-testid="tour-conductor-error" />
      }
    </div>

    <div class="col-12 md:col-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tour-outcome-label">{{'Shared.CREATE-PROSPECT.HOW_DID_THE_TOUR_GO' | translate}}</label>
      <p-select [placeholder]="'OUTCOME.CALLOUTCOME.SELECT' | translate" [options]="tourOutcomes"
        styleClass="w-full" formControlName="tour_outcome" optionLabel="name"
        aria-label="tour-outcome-dropdown"
        data-testid="tour-outcome-dropdown">
        <ng-template pTemplate="selectedItem">
          @if (selectedOutcomeFormControl.value) {
            <div class="flex align-items-center">
              <span class="mr-2"><i style="color:'{{ selectedOutcomeFormControl.value.iconColor }}'"
              class="{{ selectedOutcomeFormControl.value.icon }}"></i></span>
              <strong>{{ selectedOutcomeFormControl.value.name }}</strong>
            </div>
          }
        </ng-template>
        <ng-template let-outcome pTemplate="item">
          <div class="flex align-items-center">
            <span class="mr-2"><i style="color:'{{ outcome.iconColor }}'" class="{{ outcome.icon }}"></i></span>
            <div class="text-sm text-600">{{ 'OUTCOME.TOUROUTCOME.'+ outcome.key | translate }}</div>
          </div>
        </ng-template>
      </p-select>
      @if (parentForm().get('tour_completed.tour_outcome') && parentForm().get('tour_completed.tour_outcome')?.touched && parentForm().get('tour_completed.tour_outcome')?.invalid) {
        <app-error-msg [errors]="parentForm().get('tour_completed.tour_outcome')?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.HOW_DID_THE_TOUR_GO_ERROR' | translate" data-testid="tour-outcome-error" />
      }
    </div>

    @if (selectedOutcomeFormControl.value && selectedOutcomeFormControl.value.shortname == 'reschedule') {
      <div class="col-6 md:col-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tour-schedule-label">{{'Shared.CREATE-PROSPECT.HOW_DID_THE_TOUR_GO' | translate}}</label>
        <p-datepicker formControlName="scheduled_datetime" [showIcon]="true" dateFormat="M dd,yy" [yearNavigator]="true"
          yearRange="2023:2030" placeholder="Select Date" inputStyleClass="text-sm" styleClass="w-full text-sm"
          [maxDate]="maxDate"
          aria-label="tour-schedule-date-input"
          data-testid="tour-schedule-date-input" />
        @if (parentForm().get('tour_completed.scheduled_datetime') && parentForm().get('tour_completed.scheduled_datetime')?.touched && parentForm().get('tour_completed.scheduled_datetime')?.invalid) {
          <app-error-msg [errors]="parentForm().get('tour_completed.scheduled_datetime')?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.TOUR_COMPLETED_ON_ERROR' | translate" data-testid="tour-schedule-error" />
        }
      </div>
    }

    <div class="col-12" [style.display]="selectedOutcomeFormControl.value && selectedOutcomeFormControl.value.shortname == 'booktrial' ? 'none' : 'block'">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tour-notes-label">{{'Shared.CREATE-PROSPECT.NOTES' | translate}}</label>
      <textarea pInputTextarea formControlName="notes" class="w-full h-3rem"
        aria-label="tour-notes-input"
        data-testid="tour-notes-input">
      </textarea>
      @if (parentForm().get('tour_completed.notes') && parentForm().get('tour_completed.notes')?.touched && parentForm().get('tour_completed.notes')?.invalid) {
        <app-error-msg [errors]="parentForm().get('tour_completed.notes')?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.NOTES' | translate" data-testid="tour-notes-error" />
      }
    </div>
  </div>
  @if (selectedOutcomeFormControl.value && selectedOutcomeFormControl.value.shortname === 'booktrial') {
    <div class="border-1 border-300 border-round p-3">
      @if (selectedOutcomeFormControl.value && selectedOutcomeFormControl.value.shortname === 'booktrial') {
        <walk-in-trial [formType]="formType" [parentForm]="parentForm()" [staffList]="staffList() | async"
          aria-label="walk-in-trial-section"
          data-testid="walk-in-trial-section" />
      }
    </div>
  }
</div>